import React from 'react';
import Skeleton from 'react-loading-skeleton';

const CrmRestrictionsListRowSkeleton = () => {
  return (
    <div className="crm-restrictions-list-row  mr-4">
      <Skeleton height={30} />
    </div>
  );
};

export default CrmRestrictionsListRowSkeleton;
